import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
//components
import { TextField, PasswordField } from '../../components/hook-form';
// @form
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// utils
import { REGEXP_PASSWORD } from '../../utils/regexp';
// styles
import { AuthWrapper, FormTitle, Message, PrimaryButton, NextButton } from '../../styles';
// apis
import { changePassword, nextTime } from '../../apis';

// ----------------------------------------------------------------------

interface Props {
  current?: string;
  new?: string;
  confirm?: string;
};

// ----------------------------------------------------------------------

const schema = yup.object().shape({
  current: yup.string()
    .required(),
  new: yup.string()
    .required()
    .matches(REGEXP_PASSWORD, '비밀번호 형식을 확인해 주세요.'),
  confirm: yup.string()
    .required()
    .oneOf([yup.ref('new'), null], '비밀번호가 일치하지 않습니다.')
});

// ----------------------------------------------------------------------

export default function PasswordPage() {
  const navigate  = useNavigate();

  const { temp, expiration } = useLocation().state;

  const {
    control,
    watch,
    trigger,
    handleSubmit
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      current: '',
      new: '',
      confirm: ''
    }
  });
  
  const [ submit, setSumbit ] = useState(false);

  useEffect(() => {
    if ( submit ) trigger('confirm');
  }, [watch('new')]);

  const [ message, setMessage ] = useState(null);

  const handleNext = async () => {
    await nextTime()
      .then(() => navigate('/real-time', {state: { submit: true }}))
      .catch(() => setMessage('나중에 다시 시도해 주세요.'));
  };

  const onError = async () => {
    if ( !submit ) setSumbit(true);
  };

  const onSubmit = async (data: Props) => {
    if ( !submit ) setSumbit(true);
    await changePassword(data.current, data.new, temp)
      .then(() => {
        navigate('/success', {state: { submit: true, type: 'password' }})
      })
      .catch((error) => setMessage(error.message));
  }; 

  return (
    <AuthWrapper>
        <FormTitle>
          <p>비밀번호 변경 안내</p>
          <span>
            개인 정보 보호를 위하여 비밀번호 변경을 안내해 드리고 있습니다.<br />
            안전한 비밀번호로 변경 부탁드립니다.
          </span>
        </FormTitle>

        <form onSubmit={ handleSubmit(onSubmit, onError) }>
          <TextField
            type='password'
            name='current'
            label='현재 비밀번호' 
            control={control}
            autoComplete='current-password'
          />
          
          <PasswordField
            name='new'
            label='신규 비밀번호'
            control={control}
            autoComplete='new-password'
          />

          <PasswordField
            name='confirm'
            label='비밀번호 확인'
            control={control}
            autoComplete='new-password'
          />

          <Message $visible={message ? true : false}>{ message }</Message>

          <PrimaryButton type='submit'>확인</PrimaryButton>
        </form>

        { expiration &&
          <NextButton onClick={() => handleNext()}>다음에 변경<div /></NextButton>
        }
    </AuthWrapper>
  );
}